import { AttachmentFileTypes } from '../constants/file.constants';
import { AttachmentType } from './Enums';

export class Attachment {
  name: string;
  blobName?: string;
  blobUrl?: string;
  extension: string;
  type: AttachmentFileTypes;
  comment: string;
  attachmentType?: AttachmentType;
  existing?: boolean = false;
  isScanForAsset? : boolean = false;
  isAfter?: boolean = false;

  getId() {
    return this.blobName.substring(0, this.blobName.lastIndexOf('.'));
  }
}
